const utils = {
  timeResult(data, separator = '-') {
    /*传入 年-月-日 格式的时间，提取年月日*/
    let result = {};
    let array = data.split(separator);
    result.year = array[0];
    result.month = array[1];
    result.day = array[2];
    return result;
  },
  mapUrl(data) {
    // data需携带L1,L2,L3及id，L3目前没用
    const id = encodeURIComponent(data.id)
    if (data.L1 === '中心资讯') {
      return '/index/news?id=' + id
    }
    switch (data.L2) {
      case '研究动态': return '/academic/trends/detail?id=' + id
      case '应急常识': return '/emrClass/knowledgeDetail?id=' + id
      case '成果应用': return '/studyResult/detail?id=' + id + '&type=apply'
      case '研究方向': return '/introduce/direction'
      case '研究项目': return '/introduce/item'
    }

  }
}

export default utils

/**
 * @description 将数组分割成二维数组，其中第二维数组每组perCount个元素
 * @param perCount(int) 分割成多少个一组
 * @note 其实不如使用lodash……
 */
Array.prototype.split = function(perCount) {
  let ret = [], sub = []
  this.forEach((item, index) => {
    sub.push(item)
    if (index % perCount === perCount - 1) {
      ret.push(sub)
      sub = []
    }
  })
  if (this.length % perCount !== 0) {
    // 剩下未满 perCount 的数据
    ret.push(sub)
  }
  return ret
}